import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <img src='logo192.png' width={"100%"} style={{maxHeight:'100vh'}}/>
    </div>
  );
}

export default App;
